var map = {
	"./template.bet575": 1102,
	"./template.bet575.tsx": 1102,
	"./template.bet777": 1103,
	"./template.bet777.tsx": 1103,
	"./template.betprofessor": 1104,
	"./template.betprofessor.tsx": 1104,
	"./template.betroyale": 1105,
	"./template.betroyale.tsx": 1105,
	"./template.betstride": 1106,
	"./template.betstride.tsx": 1106,
	"./template.buffalobet": 1107,
	"./template.buffalobet.tsx": 1107,
	"./template.chromabet": 1108,
	"./template.chromabet.tsx": 1108,
	"./template.default": 718,
	"./template.default.tsx": 718,
	"./template.epicodds": 1109,
	"./template.epicodds.tsx": 1109,
	"./template.fiestabet": 2056,
	"./template.fiestabet.tsx": 2056,
	"./template.gigabet": 1117,
	"./template.gigabet.tsx": 1117,
	"./template.goldenbet888": 1118,
	"./template.goldenbet888.tsx": 1118,
	"./template.goldenrush": 1119,
	"./template.goldenrush.tsx": 1119,
	"./template.hyperbet": 1120,
	"./template.hyperbet.tsx": 1120,
	"./template.juicybet": 2057,
	"./template.juicybet.tsx": 2057,
	"./template.junglebet": 2058,
	"./template.junglebet.tsx": 2058,
	"./template.magnumbet": 1121,
	"./template.magnumbet.tsx": 1121,
	"./template.oldgill": 1122,
	"./template.oldgill.tsx": 1122,
	"./template.puntcity": 1123,
	"./template.puntcity.tsx": 1123,
	"./template.puntgenie": 2059,
	"./template.puntgenie.tsx": 2059,
	"./template.pyramidbet": 1124,
	"./template.pyramidbet.tsx": 1124,
	"./template.questbet": 1125,
	"./template.questbet.tsx": 1125,
	"./template.slambet": 1126,
	"./template.slambet.tsx": 1126,
	"./template.sterlingparker": 1127,
	"./template.sterlingparker.tsx": 1127,
	"./template.sugarcastle": 1128,
	"./template.sugarcastle.tsx": 1128,
	"./template.templebet": 1129,
	"./template.templebet.tsx": 1129,
	"./template.titanbet": 1130,
	"./template.titanbet.tsx": 1130,
	"./template.ts": 969,
	"./template.vikingbet": 1131,
	"./template.vikingbet.tsx": 1131,
	"./template.volcanobet": 1132,
	"./template.volcanobet.tsx": 1132,
	"./template.wellbet": 1133,
	"./template.wellbet.tsx": 1133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2426;